<!-- 订单详情 -->
<template>
  <div class="order-details business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="order-details-main">
      <div class="order-status">
        <div class="order-status1">
          <div>订单号：{{tableData.OrderCode}}</div>
          <div class="status-text">{{tableData.StateName}}</div>
          <div class="print">
            <div style="display:inline-block;cursor: pointer;" @click="printOrder">
              <i class="fa fa-print"></i>打印订单</div>
          </div>
        </div>
        <div class="order-status2">
          <div class="order-dur">订单状态</div>
          <el-steps :active="StepsIndex" align-center>
            <el-step
              v-for="item in tableData.Steps"
              :key="item.State"
              :title="item.State"
              :description="item.TriggerTime"
              v-if="item.State.indexOf('付款') === -1"
            ></el-step>
          </el-steps>
        </div>
      </div>

      <div class="section-title" v-if="carModel">
          <div>
              <span>车主信息</span>
          </div>
      </div>
      <div class="search-ctn" v-if="carModel">
          <el-form
              :model="carModel"
              ref="CarModel"
              label-width="100px"
              style="width: 100%;padding-right:30px;padding-left:30px"
          >
              <el-row :gutter="20">
                  <el-col :span="6">
                      <div class="grid-content bg-purple">
                          <el-form-item
                              label="车主"
                              prop="UName"
                          >
                              <el-input
                                  :disabled="true"
                                  v-model.trim="carModel.UName"
                              ></el-input>
                          </el-form-item>
                      </div>
                  </el-col>
                  <el-col :span="6">
                      <div class="grid-content bg-purple">
                          <el-form-item
                              label="联系电话"
                              prop="PhoneNum"
                          >
                              <el-input
                                  :disabled="true"
                                  v-model.trim="carModel.PhoneNum"
                              ></el-input>
                          </el-form-item>
                      </div>
                  </el-col>
              </el-row>
              <el-row :gutter="20">
                  <el-col :span="12">
                      <div class="grid-content bg-purple">
                          <el-form-item
                              label="车辆"
                              prop="CarDesc"
                          >
                              <el-input
                                  :disabled="true"
                                  v-model.trim="carModel.CarDesc"
                              ></el-input>
                          </el-form-item>
                      </div>
                  </el-col>
              </el-row>
              <el-row :gutter="20">
                  <el-col :span="6">
                      <div class="grid-content bg-purple">
                          <el-form-item
                              label="车牌号"
                              prop="CarNum"
                          >
                              <el-input
                                  :disabled="true"
                                  v-model.trim="carModel.CarNum"
                              ></el-input>
                          </el-form-item>
                      </div>
                  </el-col>
                  <el-col :span="6">
                      <div class="grid-content bg-purple">
                          <el-form-item
                              label="车架号"
                              prop="VehicleCode"
                          >
                              <el-input
                                  :disabled="true"
                                  v-model.trim="carModel.VehicleCode"
                              ></el-input>
                          </el-form-item>
                      </div>
                  </el-col>
                  <el-col :span="6">
                      <div class="grid-content bg-purple">
                          <el-form-item
                              label="发动机号"
                              prop="EngineNum"
                          >
                              <el-input
                                  :disabled="true"
                                  v-model.trim="carModel.EngineNum"
                              ></el-input>
                          </el-form-item>
                      </div>
                  </el-col>
              </el-row>
          </el-form>
      </div>
      <div class="section-title">
        <div>检修结果</div>
      </div>
      <div style="height: 200px;overflow-y: auto;padding: 12px 15px;border: 1px solid #ccc;box-shadow: 0 0 5px #ddd; ">
        <p v-html="tableData.Remark">{{tableData.Remark}}</p>
      </div>      
      <el-card class="box-card" style="margin-bottom: 20px;">
        <div class="section-title">
            <div>维修配件</div>
        </div>        
        <div  style="padding: 10px">
          <div class="table-ctn">
            <el-table
              :header-cell-style="{background:'#F2F6FC'}"
              :data="tableData.Goods"
              style="width: 100%"
            >
              <el-table-column width="390" label="商品">
                <template slot-scope="scope">
                  <div class="shop-msg">
                    <div class="image-ctn">
                      <img
                        :src="scope.row.GoodsImg ? downloadUrl + scope.row.GoodsImg : ''"
                        alt
                        class="shop-cover"
                        :onerror="defaultImg"
                      />
                    </div>
                    <p style="margin-left: 10px">{{scope.row.GoodsName}}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="GoodsCode" label="商品编号"></el-table-column>
              <el-table-column prop="ShopPrice" label="价格(元)">
                <template slot-scope="scope">
                  <span v-if="scope.row.GoodsId">{{scope.row.ShopPrice}}</span>
                  <span v-else style="color:red;">待询价</span>
                </template>
              </el-table-column>
              <el-table-column prop="InstallationFee" label="安装费用"></el-table-column>
              <el-table-column prop="ActualCount" label="商品数量"></el-table-column>
              <!-- <el-table-column prop="Discount" label="优惠金额"></el-table-column> -->
              <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="ops-ctn" v-if="StepsIndex == 6">
                    <el-button
                      @click="gotoGoodsDetails(scope.row.GoodsId)"
                      size="mini"
                      type="text"
                    >再次购买</el-button>
                    <el-button
                      @click="gotoApplyDetails(scope.row.GoodsId)"
                      size="mini"
                      type="text"
                    >申请售后</el-button>
                  </div>
                </template>
              </el-table-column>-->
            </el-table>
          </div>
          <div class="money-msg">
            <div>
              <div class="money-item">
                <span class="key">商品总额：</span>
                <span class="value">￥{{tableData.OrderAmount}}</span>
              </div>
              <!-- <div class="money-item">
                <span class="key">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠：</span>
                <span class="value">￥{{tableData.DiscountsMoney}}</span>
              </div> -->
              <!--<div class="money-item">-->
              <!--<span class="key">运&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;费：</span>-->
              <!--<span class="value">￥{{tableData.GoodsAmount}}</span>-->
              <!--</div>-->
              <div class="money-item all-money">
                <span class="key">应付总额：</span>
                <span class="value font-md">￥{{tableData.PaymentAmount}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: { breadcrumb },
  data() {
      let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      browseId: "",
      StepsIndex: 0,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      OrderId: null,
      RecordId: null,
      tableData: {},
      permission: {},
      carModel: {},
    };
  },
  mounted() {
    this.browseId = this.$route.query.OrderId
      ? this.$route.query.OrderId
      : this.$route.query.RecordId;
    this.OrderId = this.$route.query.OrderId;
    this.RecordId = this.$route.query.RecordId;
    this.getTableData();
  },
  methods: {
    gotoApplyDetails(GoodId) {
      this.$util
        .axiosGet({
          url: `/api/MallSaleOrder/GetAfterSaleSaleOrder`,
          data: {
            UserId: this.userMsg.EmployeeId,
            OrderType: 10,
            OrderId: this.OrderId,
            OrderGoodRId: ""
          }
        })
        .then(res => {
          let data = res.data[0];
          if (data && data.Detail[0]) {
            this.$router.push(
              `../service/afterApplyDetails?OrderId=${this.OrderId}&OrderCode=${
                this.tableData.OrderCode
              }&GoodId=${GoodId ? GoodId : ""}`
            );
          } else {
            this.$util.warningMsg("当前订单无法申请售后");
          }
        });
    },
    // 跳转商品详情
    gotoGoodsDetails(id) {
      this.$router.push("../search/goodsDetail?id=" + id);
    },
    // 获取数据
    getTableData() {
      this.$util
        .axiosGet({
          url: "api/CustomerManagement/OrderDetails",
          data: {
            RecordId: this.RecordId,
            OrderId: this.OrderId
          }
        })
        .then(res => {
          let data = res.data;
          let Steps = data.Steps;
          for (let i = 0; i < Steps.length; i++) {
            if (Steps[i].IsCurrStep) {
              if (i == Steps.length - 1) {
                this.StepsIndex = Steps.length;
              } else {
                this.StepsIndex = i;
              }
              break;
            }
          }
          this.tableData = data;
          this.carModel=data.CarModel;
        }).catch(()=>{});
    },
    printOrder() {
      let that = this;
      this.$util.elConfirm({
        content: "确定要打印维修单？",
        noMsg: true,
        confirm() {
          that.$util
            .axiosPost({
              url: `/api/CustomerManagement/PrintRepairOrder`,
              data:{
                orderIds:that.tableData.OrderId,
                staffId:that.userMsg.EmployeeId
              }
            })
            .then((resp) => {
              if(resp.errcode==0)
                that.$util.successMsg("打印成功");
            })
            .catch(() => {});
        }
      });
    },
    // 返回上一层
    back() {
      window.history.back(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.image-ctn {
  width: 80px;
  height: 80px;
  overflow: hidden;
  img {
    max-width: 80px;
    max-height: 80px;
  }
}
.bread-nav {
  justify-content: space-between;
  align-items: center;
}
.order-status {
  display: flex;
  background: @border4Color;
  padding: 20px;
  margin-bottom: 20px;
}

.order-status1 {
  width: 20%;
  border-right: 1px solid @border3Color;
  text-align: center;
  div {
    margin-bottom: 20px;
  }
}
.status-text {
  font-size: @font-lg;
  color: @theme2;
  font-weight: bold;
}

.order-status2 {
  width: 80%;
  padding-left: 20px;
}
.order-dur {
  padding-bottom: 20px;
}
.shop-msg {
  display: flex;
  align-items: center;
}
.money-msg {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
.money-item {
  width: 182px;
  display: flex;
  justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
  .key {
    flex-shrink: 0;
  }
}
.all-money {
  color: red;
}
.back {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: @font-md;
  color: @theme;
  i {
    font-size: 24px;
    margin-right: 10px;
  }
}
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 20px;
  margin-bottom: 20px;
}
</style>
